import type { RouteRecordRaw } from "vue-router";

export const errorRoutes: RouteRecordRaw[] = [
  {
    path: "/error/forbidden",
    name: "error-forbidden",
    component: () => import(/* webpackChunkName: "dashboard-error" */ "../../components/error/ForbiddenView.vue"),
    meta: {
      titleKey: "pageTitle.error.forbidden",
      layout: "chrome-free",
      viewGroup: "error-forbidden"
    }
  },
  {
    path: "/error/page-not-found",
    name: "error-page-not-found",
    component: () => import(/* webpackChunkName: "dashboard-error" */ "../../components/error/PageNotFoundView.vue"),
    meta: {
      titleKey: "pageTitle.error.pageNotFound",
      layout: "chrome-free",
      viewGroup: "error-page-not-found"
    }
  },
  {
    path: "/error/internal-error",
    name: "error-internal-error",
    component: () => import(/* webpackChunkName: "dashboard-error" */ "../../components/error/InternalErrorView.vue"),
    meta: {
      titleKey: "pageTitle.error.internalError",
      layout: "chrome-free",
      viewGroup: "error-internal-error"
    }
  },
  {
    path: "/error/secure-zone",
    name: "error-secure-zone",
    component: () => import(/* webpackChunkName: "dashboard-error" */ "../../components/error/SecureZoneView.vue"),
    meta: {
      titleKey: "pageTitle.error.secureZone",
      layout: "chrome-free",
      viewGroup: "error-secure-zone"
    }
  },
  {
    path: "/error/upgrade-web-browser",
    name: "error-upgrade-web-browser",
    component: () =>
      import(/* webpackChunkName: "dashboard-error" */ "../../components/error/UpgradeWebBrowserView.vue"),
    meta: {
      titleKey: "pageTitle.error.upgradeWebBrowser",
      layout: "chrome-free",
      viewGroup: "error-upgrade-web-browser"
    }
  }
];
